import {Component, ElementRef, Input, OnDestroy, OnInit, ViewChild, ViewChildren} from '@angular/core';
import {ControlContainer, NgForm, NgModel} from '@angular/forms';

import {EditModalSectionBaseComponent} from '../edit-modal-section-base.component';
import {EditModalService} from '../../../services/edit-modal.service';
import {MyEditDialogStepsEnum} from '../../../enums/my-edit-dialog-steps.enum';
import {BdLabeledDateInputComponent} from '@brother-apps/brother-dealerapp-shared-lib';
import {Subscription} from 'rxjs';
import {ModalVisibilityService} from '../../../services/modal-visibility.service';

@Component({
    selector: 'app-projects-project-data-editor',
    templateUrl: './project-data-editor.component.html',
    styleUrls: ['./project-data-editor.component.scss'],
    viewProviders: [ { provide: ControlContainer, useExisting: NgForm }]
})
export class ProjectsProjectDataEditorComponent extends EditModalSectionBaseComponent  implements OnInit, OnDestroy  {
    @ViewChildren(BdLabeledDateInputComponent) bdLabeledDateInputs: BdLabeledDateInputComponent[];
    private closeEditDialogModalsSub: Subscription;

    @Input() public forceFormValidationVisibility: boolean;

    constructor( public  editModalService: EditModalService,
                 private modalVisibilityService: ModalVisibilityService) {
        super(editModalService);
    }

    public ngOnInit() {
        super.ngOnInit();
        this.closeEditDialogModalsSub = this.modalVisibilityService.closeEditDialogModalsRequestAnnounced$.subscribe(sourceId => {

            if (sourceId !== 'edit-modal_clicked') {
                this.bdLabeledDateInputs.forEach( component =>
                    component.hideDatePicker()
                );
            }
        });
    }

    // isInternalUser(): boolean {
    //     return super.isInternalUser();
    // }

    public onQuoteClosingDateChanged() {

        setTimeout(_ => {
            this.editModalService.announceQuoteClosingDateChanged();
        }, 0);

    }

    public ngOnDestroy(): void {
        if (  this.closeEditDialogModalsSub ) {
            this.closeEditDialogModalsSub.unsubscribe();
        }
    }
}
